import styled from 'styled-components';
import colors from '@constants/Colors';

export const MainTitle = styled.h1`
  font-size: 26px;
  color: ${colors.darkSlate};
  text-align: center;
  margin-top: 48px;
  margin-bottom: 20px;
`;

export const VersionInfo = styled.p`
  margin-bottom: 32px;
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  text-align: center;
  color: ${colors.bluishGrey};
`;

export const Divisor = styled.span`
  margin: 0 12px;
`;

export const ArticleTitle = styled.h3`
  font-size: 18px;
  color: ${colors.darkSlate};
  margin-top: 48px;
  margin-bottom: 16px;
`;

export const ArticleContent = styled.p`
  color: ${colors.darkSlate};
  font-weight: 300;
  line-height: 22px;
`;
